import { useMutation } from "@apollo/client";
import useAuth from "./useAuth";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { LOGOUT_USER } from "../graphql/user";
import { useState } from "react";
import { Dialog, DialogContent, IconButton, Paper } from "@mui/material";
import { AlertIcon, CloseIcon } from "../components/Icon";
import { saveToken } from "../app/reducers/tokenSlice";
import { useDispatch } from "react-redux";
import { store } from "../app/store";

const useMutationAuth = (QUERY, objAccess = "", params) => {
	const { enqueueSnackbar } = useSnackbar();
	const dispatch = useDispatch();
	const { t } = useTranslation();
	const { logout } = useAuth();
	const [descriptionState, setDescription] = useState(false);

	// const queryName = QUERY.definitions
	//   .filter(
	//     (definition) =>
	//       definition.kind === "OperationDefinition" &&
	//       definition.operation === "mutation"
	//   )
	//   .map((definition) =>
	//     definition.selectionSet.selections.map(
	//       (selection) => selection.name.value
	//     )
	//   )
	//   .flat()[0];

	const closeModalHandler = () => {
		setDescription(false);
	};

	const [call_function, { loading, error }] = useMutation(QUERY, {
		fetchPolicy: "no-cache",
		nextFetchPolicy: "no-cache",
		...params,
	});

	const [logsOutUser] = useMutation(LOGOUT_USER, {
		fetchPolicy: "no-cache",
		nextFetchPolicy: "no-cache",
	});

	function userLogout() {
		logsOutUser({
			variables: {
				model: {
					jwtToken: store?.getState()?.token?.token,
				},
			},
			onCompleted: logout,
		});
	}

	const mfunction = (
		params,
		onCompletedFunc = undefined,
		onErrorFunc = undefined
	) => {
		call_function({
			...params,
			onCompleted: (data) => {
				if (data[objAccess]?.errorMessage === "IXIA_ACTIV_UNAUTHORIZED") {
					// const currentTime = new Date().toLocaleTimeString();
					// const token = store?.getState()?.token?.token;
					// console.error(
					//   `%c [mfunction] Unauthorized Access at ${currentTime}`,
					//   "color: red; font-weight: bold;"
					// );
					// console.log(
					//   `%c [mfunction] Query Name: ${queryName}`,
					//   "color: red; font-weight: bold;"
					// );
					// console.log(
					//   `%c [mfunction] Token: ${token}`,
					//   "color: red; font-weight: bold;"
					// );
					sessionStorage.removeItem("unsavedChanges");
					userLogout();
					enqueueSnackbar(data[objAccess].errorMessage, {
						variant: "error",
						autoHideDuration: 5000,
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
					});
				} else if (
					data[objAccess]?.errorMessage === "IXIA_ACTIV_NEW_TOKEN"
				) {
					sessionStorage.removeItem("unsavedChanges");
					const newToken = data[objAccess]?.errorVariables.trim();
					// console.log(
					//   `%c [mfunction] Refresh token triggered at ${new Date().toLocaleTimeString()}`,
					//   "color: orange; font-weight: bold;"
					// );
					// console.log(
					//   `%c [mfunction] Old token: ${store?.getState()?.token?.token}`,
					//   "color: purple; font-weight: bold;"
					// );
					// console.log(
					//   `%c [mfunction] New token received: ${newToken}`,
					//   "color: green; font-weight: bold;"
					// );
					// Update token in store before retrying
					dispatch(saveToken(newToken));
					// Retry the call with the new token in headers
					mfunction(
						{
							...params,
							context: {
								headers: {
									authorization: newToken ? "Bearer " + newToken : "",
								},
							},
						},
						onCompletedFunc,
						onErrorFunc
					);
				} else if (
					data[objAccess]?.errorMessage ===
						"IXIA_ACTIV_DESCRIPTION_REQUIRED" &&
					data[objAccess].errorCode === "err217"
				) {
					setDescription(true);
				} else if (
					data[objAccess]?.errorMessage ===
						"IXIA_ACTIV_ATTENDANCE_RECORD_NOT_SAVED" &&
					data[objAccess]?.errorCode === "err239"
				) {
					localStorage.setItem("checkedIn", false);
				} else if (
					data[objAccess]?.errorCode !== null &&
					data[objAccess]?.errorCode !== ""
				) {
					enqueueSnackbar(t(data[objAccess].errorMessage), {
						variant: "error",
						autoHideDuration: 5000,
					});
				} else if (onCompletedFunc !== undefined) {
					onCompletedFunc(data);
				}
			},
			onError: (error) => {
				enqueueSnackbar(t("systemError"), {
					variant: "error",
					autoHideDuration: 5000,
				});
				if (onErrorFunc !== undefined) onErrorFunc(error);
			},
		});
	};

	const cfunction = (
		params,
		onCompletedFunc = undefined,
		onErrorFunc = undefined
	) => {
		call_function({
			...params,
			onCompleted: (data) => {
				if (data[objAccess].errorMessage === "IXIA_ACTIV_UNAUTHORIZED") {
					sessionStorage.removeItem("unsavedChanges");
					logout();
				} else if (
					data[objAccess].errorMessage === "IXIA_ACTIV_NEW_TOKEN"
				) {
					sessionStorage.removeItem("unsavedChanges");
					const newToken = data[objAccess].errorVariables.trim();
					// console.log(
					//   `%c [cfunction] Refresh token triggered at ${new Date().toLocaleTimeString()}`,
					//   "color: orange; font-weight: bold;"
					// );
					// console.log(
					//   `%c [cfunction] Old token: ${store?.getState()?.token?.token}`,
					//   "color: purple; font-weight: bold;"
					// );
					// console.log(
					//   `%c [cfunction] New token received: ${newToken}`,
					//   "color: green; font-weight: bold;"
					// );
					// Update token in store first
					dispatch(saveToken(newToken));
					// Retry the call with the new token
					cfunction(
						{
							...params,
							context: {
								headers: {
									authorization: newToken ? "Bearer " + newToken : "",
								},
							},
						},
						onCompletedFunc,
						onErrorFunc
					);
				} else if (onCompletedFunc !== undefined) {
					onCompletedFunc(data);
				}
			},
			onError: (error) => {
				enqueueSnackbar(t("systemError"), {
					variant: "error",
					autoHideDuration: 5000,
				});
				if (onErrorFunc !== undefined) onErrorFunc(error);
			},
		});
	};

	return {
		mfunction,
		cfunction,
		loading,
		error,
		descriptionState,
		closeModalHandler,
		DialogComponent: (
			<>
				{descriptionState && (
					<Dialog
						open={descriptionState}
						onClose={closeModalHandler}
						sx={{
							"& .MuiPaper-root": {
								overflow: "hidden",
								paddingBottom: "5px",
								fontWeight: "450px",
								maxWidth: "400px",
							},
						}}
					>
						<Paper style={{ textAlign: "center" }}>
							<div
								style={{
									display: "flex",
									justifyContent: "flex-end",
									marginRight: "1rem",
								}}
							>
								<IconButton
									edge="end"
									color="inherit"
									onClick={closeModalHandler}
									aria-label="close"
								>
									<CloseIcon
										color={"#000000"}
										width={"20"}
										stroke={"1"}
									/>
								</IconButton>
							</div>
							<DialogContent
								id="description-dialog"
								sx={{ paddingTop: "0" }}
							>
								<div style={{ marginBottom: "4px" }}>
									<AlertIcon color="#ff2825" width="30" height="30" />
								</div>
								{t("useMutation.descriptionRequired")}
							</DialogContent>
						</Paper>
					</Dialog>
				)}
			</>
		),
	};
};

export default useMutationAuth;

useMutationAuth.defaultProps = {
	QUERY: null,
	objAccess: "",
	params: {},
	statusFunctions: {},
	descriptionMutation: false,
};
